module.exports = __webpack_public_path__ + "img/logo.9d65bc05.svg";